import Information from "../Information/Information";
import { useTranslation } from "react-i18next";
import Document from "../Documents/Document";
import PresaleDetailCard from "../../PresaleDetailCard";
import useProjectsData from "../../../../hooks/sales/useProjectsData";
import { useState } from "react";
import { useRoundData } from "../../../landing/Process/useRoundData";
import PresaleTimer from "../PresaleTimer";

const Banner = () => {
  const { t } = useTranslation();
  const projects = useProjectsData();
  const project = projects.find((p) => p.name === "$PRICE");

  const { roundData, refresh } = useRoundData(project);

  const [timeshow, setTimeshow] = useState(false);

  return (
    <>
      <section className="banner-detailpage banner-detailpagematchain">
        {/* <img
          src="\assets\alldetailpages\screx\bannerbg.png"
          alt="img"
          className="img-fluid banner-bg"
        /> */}
        <div className="main-background">
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="\assets\videobanner.mp4" type="video/mp4" />
          </video>
          <img src="\assets\coinimg.png" class="img-overlay1" />
          <img src="\assets\coinimgshadow.png" class="img-overlay2" />
        </div>
        <div className="main-content">
          <div className="innner_tagside">
            <div className="coin-name-and-img">
              <img src="\pricelogo.png" className="imgcoinsss" />
              <h4>$PRICE</h4>
            </div>
          </div>
          {roundData && (
            <PresaleTimer
              roundData={roundData}
              timeshow={timeshow}
              setTimeshow={setTimeshow}
              refresh={refresh}
            />
          )}
        </div>
      </section>

      <section className="bottom-part-section">
        <div className="custom-container">
          <div className="parent">
            <PresaleDetailCard
              project={project}
              t={t}
              timeshow={timeshow}
              setTimeshow={setTimeshow}
              roundData={roundData}
            />

            <div className="right-side">
              <ul
                className="nav nav-tabs banner-tabs"
                id="myTab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="home-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="home-tab-pane"
                    aria-selected="true"
                  >
                    {t("Gems-detailt2")}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="document-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#document-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="document-tab-pane"
                    aria-selected="false"
                  >
                    {t("Gems-detailt4")}
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home-tab-pane"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                  tabIndex="0"
                >
                  <Information />
                </div>
                <div
                  className="tab-pane fade"
                  id="document-tab-pane"
                  role="tabpanel"
                  aria-labelledby="document-tab"
                  tabIndex="0"
                >
                  <Document />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Banner;
